import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import moment from "moment";
import MessageModal from "../common/MessageModal.vue";
import { getData, deleteData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage";
import ConfirmModal from "@/components/common/ConfirmModal";
import { iconColor } from "@/consts/iconColor";
import { getAbsentAlert, assignAbsentBudge } from "@/services/common";
moment.locale("ja");
export default {
  name: "DetailAttendance",
  components: {
    MessageModal: MessageModal,
    LoadingMessage: LoadingMessage,
    ConfirmModal: ConfirmModal
  },
  data: function data() {
    return {
      fiscalDate: moment().add(-3, "month").year() + "-04-01",
      showModal: false,
      student: {},
      attendances: [],
      isLoading: {
        getData: true,
        deleteData: false
      },
      showConfirmModal: false,
      confirmMessageTitle: "",
      confirmMessage: "",
      targetId: null,
      absentList3: [],
      absentList20: []
    };
  },
  created: function created() {
    this.setData();
  },
  methods: {
    iconColor: iconColor,
    getAttendance: function getAttendance() {
      var _this = this;

      getData("attendances?student_id=" + this.$route.query.student_id + "&orderby=created_at&order=desc&show_daily_all=1").then(function (data) {
        var attendances = [];
        data.items.forEach(function (v) {
          var found = false;
          attendances.forEach(function (v2) {
            if (v2.date === v.date) {
              if (v2["history"]) {
                v2["history"].push(v);
              } else {
                v2["history"] = [v];
              }

              found = true;
            }
          });

          if (!found) {
            v.showAction = moment(v.date) >= moment(_this.fiscalDate);
            attendances.push(v);
          }

          v.isDeleted = !v.is_daily_latest;
        }); // 表示の整形

        data.items.forEach(function (v) {
          v.date = moment(v.date).format("YYYY年MM月DD日");
          v.created_at = moment(v.created_at).format("YYYY年MM月DD日 HH:mm");
        });
        _this.attendances = attendances;
      }).catch(function (error) {
        console.log(error);
      });
    },
    setData: function setData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var a, absentList3, absentList20, absentList30, d, student;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getAbsentAlert();

              case 2:
                a = _context.sent;
                absentList3 = a.absentList3;
                absentList20 = a.absentList20;
                absentList30 = a.absentList30;
                _context.next = 8;
                return getData("students/" + _this2.$route.query.student_id);

              case 8:
                d = _context.sent;
                student = d && d.items[0];
                student.absents = assignAbsentBudge(student, absentList3, absentList20, absentList30);
                _this2.student = student;
                _this2.isLoading.getData = false;

                _this2.getAttendance();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.getAttendance();
    },
    confirmDeleteData: function confirmDeleteData(id) {
      this.confirmMessageTitle = "出欠席情報削除";
      this.confirmMessage = "出欠席情報を削除します。よろしいですか？";
      this.targetId = id;
      this.showConfirmModal = true;
    },
    cancelConfirm: function cancelConfirm() {
      this.showConfirmModal = false;
    },
    removeAttendance: function removeAttendance() {
      var _this3 = this;

      this.isLoading.deleteData = true;
      deleteData("attendances/" + this.targetId).then(function () {
        _this3.$store.dispatch("commitModalMessage", {
          message: "出欠席情報が削除されました",
          title: "削除完了"
        });

        _this3.showModal = true;
      }).catch(function (error) {
        _this3.$store.dispatch("commitModalMessage", {
          message: "出欠席情報を削除できませんでした",
          title: "エラー"
        });

        _this3.showModal = true;
        console.log(error);
      }).then(function () {
        _this3.isLoading.deleteData = false;
        _this3.showConfirmModal = false;
      });
    }
  }
};